import moment from 'moment';
import jwtAxios from "../services/axiosInstance/ApiConfig";

export const phoneRegExp = /^((\\+[1-9]{1,4}[ \\-]*)|(\\([0-9]{2,3}\\)[ \\-]*)|([0-9]{2,4})[ \\-]*)*?[0-9]{3,4}?[ \\-]*[0-9]{3,4}?$/

export const clearLocalStorage = () => {
    localStorage.clear()
}
  
export const setAuthToken = (token: string, refresh: string) => {
    if (token) {
        // jwtAxios.defaults.headers.common['Authorization'] = 'Bearer ' + token;
        localStorage.setItem('token', token);
        localStorage.setItem('refresh', refresh);
    } else {
        delete jwtAxios.defaults.headers.common['Authorization'];
        localStorage.removeItem('token');
        localStorage.removeItem('refresh');
    }
};

export const getAuthUser = () => {
    return localStorage.getItem('auth_user')
}

export const getAuthToken = () => {
    return localStorage.getItem('token')
}

export const dateFormatToLocalString = (date: string) => {
    return moment(date).format('DD MMM, YYYY')
}

export const getBooleanFormattedValue = (value: boolean) => {
    return value === false ? 'False' : 'True'
}

export const calculatePrice = (cartItems: any) => {
    let total = 0
    for(let i = 0; i < cartItems.length; i++) {
        total += (cartItems[i].price * cartItems[i].qty)
    }
    return total.toFixed(0);
}

export const calculateTotalPrice = (cartItems: any) => {
    let total = 0
    for(let i = 0; i < cartItems.length; i++) {
        total += (cartItems[i].price * cartItems[i].qty) - getDiscount(cartItems[i].price, (cartItems[i].discount || 10))
    }
    return total.toFixed(0);
}

export const calculateTotalDiscount = (cartItems: any) => {
    let totalDiscount = 0
    for(let i=0; i < cartItems.length; i++) {
        totalDiscount += getDiscount(cartItems[i].price * cartItems[i].qty, cartItems[i].discount || 10)
    }
    return totalDiscount.toFixed(0);
}

export const getDiscount = (price: number, discount: number) => {
    return (price * discount) / 100
}

export const getTomorrowsDate = (nods: number) => {
    const todayMoment = moment()
    const tomorrowMoment = todayMoment.clone().add(nods,'days')
    return tomorrowMoment.format('dddd MMMM D')
}

export const productColorsList = [
    'Red', 'Green', 'Yellow', 'Blue', 'White', 'Black', 'Navy Blue'
];

export const productSizeList = [
    'XS', 'S', 'M', 'L', 'XL', 'XLL'
];
